import { useNavigate, useSearchParams } from "react-router-dom";
import CatalogEntryLaunchConfigurationSelector from "../components/detail/CatalogEntryLaunchConfigurationSelector";
import { useCatalogLaunch } from "./CatalogLaunchContext";
import {
  getSelfDirectedLaunchConfigurations,
  isSelfDirectedLaunchConfiguration,
} from "./catalogLaunchConfigurations";

export default function CatalogLaunchRuntimeLaunchConfigurationControl() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const {
    catalogEntry,
    selectedLaunchConfigurationId
  } = useCatalogLaunch();
  const availableLaunchConfigurations =
    getSelfDirectedLaunchConfigurations(catalogEntry, {
      respectAudience: false
    });
  const selectedLaunchConfiguration =
    availableLaunchConfigurations.find(
      (configuration) =>
        configuration?.id ===
        selectedLaunchConfigurationId
    ) ||
    catalogEntry?.metadata?.ux?.launchConfigurations?.find(
      (configuration) =>
        configuration?.id ===
        selectedLaunchConfigurationId
    ) ||
    null;
  const isSelfDirectedSelection =
    isSelfDirectedLaunchConfiguration(
      selectedLaunchConfiguration
    );

  if (
    !catalogEntry ||
    availableLaunchConfigurations.length <= 1 ||
    !isSelfDirectedSelection
  ) {
    return null;
  }

  return (
    <CatalogEntryLaunchConfigurationSelector
      entry={catalogEntry}
      selectedLaunchConfigurationId={selectedLaunchConfigurationId}
      availableLaunchConfigurations={availableLaunchConfigurations}
      showPreferenceControl
      onChange={(nextLaunchConfigurationId) => {
        const nextSearchParams = new URLSearchParams(searchParams);
        nextSearchParams.set("launchConfig", nextLaunchConfigurationId);
        navigate({
          pathname: `/app/${catalogEntry.slug}/open`,
          search: `?${nextSearchParams.toString()}`
        });
      }}
    />
  );
}
